import { getIsInFlowsItem } from "../../reducers/session";

import React from "react";
import { useSelector } from "react-redux";

import languageShape from "./shapes/languageShape";
import { IAppState } from "../../types/stores";

type Props = {
    controlKey: string;
    filterPlaceholder: string;
    filterValue: string;
    id: string;
    lang: languageShape;
    onFilterChange: any;
};

const Filter: React.FC<Props> = ({ controlKey, filterPlaceholder, filterValue, id, lang, onFilterChange }: Props) => {
    const isInFlowsItem = useSelector((state: IAppState) => getIsInFlowsItem(state));

    let filter = (
        <div className="rdl-filter-container">
            <label className="rdl-control-label rdl-sr-only" htmlFor={`${id}-filter-${controlKey}`}>
                {lang[`${controlKey}FilterHeader`]}
            </label>
            <input
                className="rdl-filter"
                data-key={controlKey}
                id={`${id}-filter-${controlKey}`}
                placeholder={filterPlaceholder}
                type="text"
                value={filterValue}
                onChange={onFilterChange}
            />
        </div>
    );

    if (isInFlowsItem) {
        filter = (
            <div className="rdl-filter-container">
                <input
                    data-key={controlKey}
                    id={`${id}-filter-${controlKey}`}
                    placeholder={filterPlaceholder}
                    type="text"
                    value={filterValue}
                    onChange={onFilterChange}
                    style={{
                        width: "100%",
                        marginBottom: 20,
                        fontSize: 14,
                        marginTop: "-4px",
                    }}
                    className={"material-filter"}
                />
            </div>
        );
    }

    return filter;
};

export default Filter;
